import { fragmentToString } from "./helpers";

export function LreSideDrawer(elementTemplate, elementOfBody = false) {
    const self = this;
    this.drawerTemplate = elementTemplate;
    this.drawer = null;
    this.instanceId = null;
    this.templStr = null;
    this._findAndReplace = {}
    this.isReady = false;
    this.options = {
        removeOnClose: true,
        hasReplacementStrings: false,
        closeOnClick: false,
    }

    this.initControl = () => {
        if ( elementOfBody ) {
            this.processLoadElement()
        }
        // On window resize, call the resize drawer method
        window.addEventListener('resize', this.helpers.resizeDrawer);
    }

    this.destroyControl = () => {
        window.removeEventListener('resize', this.helpers.resizeDrawer);
    }

    this.processLoadElement = () => {
        if ( !elementOfBody ) {
            if ( !this.templStr ) {
                this.templStr = fragmentToString(this.drawerTemplate);
            }

            let replacedTemplStr = this.helpers.runReplacementOnStr(this.templStr);
            this.drawer = this.helpers.strToHtml(replacedTemplStr);

            document.body.appendChild(this.drawer);
        } else {
            this.drawer = this.drawerTemplate;
        }

        this.drawer.removeAttribute('xmlns');

        this.helpers.resizeDrawer();

        if ( this.options.closeOnClick ) {
            this.drawer.classList.add('hoh-team-details-sidedrawer--close-on-click');
        }
    }

    this.loadElement = (callback) => {
        if ( !this.isReady ) {
            this.processLoadElement();
            this.isReady = true;
        } else {
            if ( this.options.removeOnClose ) {
                this.processLoadElement();
            }
        }

        if ( callback && typeof callback === 'function' ) {
            callback();
        }
    }

    this.helpers = {
        convertFragmentToDOM: function(fragment) {
            let divElement = document.createElement('div');
            LREAPI.dom.setStyle(divElement, {
                display: 'none',
            });

            divElement.appendChild(fragment);
            document.body.appendChild(divElement);
            var elElement = divElement.firstElementChild;
            // divElement.remove();
            return elElement;
        },
        strToHtml: function(str) {
            var parsed = new DOMParser().parseFromString(str, 'text/html');
            if (parsed.body.firstChild) {
                return parsed.body.firstChild;
            }
            return parsed.head.firstChild;
        },
        runReplacementOnStr: function(str) {
            if ( !self.options.hasReplacementStrings ) {
                return str;
            }

            for (const key in self._findAndReplace) {
                str = str.replace(new RegExp(key, 'g'), self._findAndReplace[key]);
            }
            return str;
        },
        resizeDrawer: function() {
            if ( !self.drawer ) {
                return;
            }

            let browserFullWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            $iCore.helper.dom.setStyle(self.drawer, {
                width: `${browserFullWidth}px`,
                left: 0
            });
        }
    }

    this.show = () => {
        this.loadElement( () => {
            $iCore.actions.destroyLenis();
            setTimeout(() => {
                this.drawer.classList.add('is-opened');
                document.body.classList.add('hoh-sidedrawer--is-opened');
            }, 100);
            if ( this.options.closeOnClick ) {
                this.drawer.addEventListener('click', this.hide.bind(this));
            }
        });
    }

    this.generateInstanceId = () => {
        this.instanceId = `sd-${Math.floor(Math.random() * 100000000)}`;
    }

    this.hide = () => {
        this.drawer.classList.remove('is-opened');
        document.body.classList.remove('hoh-sidedrawer--is-opened');
        let destroyDrawer = function(drawer, evt) {
            drawer.removeEventListener('transitionend', destroyDrawer.bind(this, drawer));
            if ( self.options.removeOnClose ) {
                drawer.remove();
            }
        }
        this.drawer.addEventListener('transitionend', destroyDrawer.bind(this, this.drawer));
        $iCore.actions.initializeLenis();
    }

    this.findAndReplace = (search, replacement) => {
        this._findAndReplace[search] = replacement;
        this.options.hasReplacementStrings = true;
        return this;
    }

    this.removeOnClose = (removeElement = true) => {
        this.options.removeOnClose = removeElement;
        return this;
    }

    this.closeOnClick = (closeOnClick = false) => {
        this.options.closeOnClick = closeOnClick;
        return this;
    }

    function __constructor() {
        self.generateInstanceId();
        self.initControl();
    }
    __constructor();
}